module.exports = __webpack_public_path__ + "img/ATV.2e3f87bf.png";